module.exports = __webpack_public_path__ + "static/media/vorxis-2.c44087e8.jpg";